import _ from '/home/ps/root'
// import configureStore from './store/configureStore'
// import {dispatch} from './io/index.js'
// import {Toast} from './component/master/toast'
// import React, {useState, useEffect} from 'react'
const ID = 'global'
// export const JSONDELIVER='jsondeliver', REVIEWS='reviews', FILES='medias', ITEMS='items', SELFILE='selectmedia', SELITEM='selectitem', SUBTOTAL='subtotal', AUTOSEND='autosend'
export const Fields = {}
// export const Ref = {}
export const eId = id => document.getElementById(id)
export const Ref = {Modified: {}, Interval: 5, Exit: false, Task: [], Net: {}}
// export const getIO = arg => arg ? IO[arg] : IO
export const minutesToHoursAndMinutes = totalMinutes => {
  const h = Math.floor(totalMinutes / 60) // Get the whole number of hours
  const m = Math.round(totalMinutes % 60) // Get the remaining minutes
  const h0 = h > 0, h1 = h > 1
  const m0 = m > 0, m1 = m > 1
  const hour = `${h0 ? h : ''}${h0 ? ' hour' : ''}${h1 ? 's' : ''}`
  const minute = `${m0 ? m : ''}${m0 ? ' minute' : ''}${m1 ? 's': ''}`
  return  `${hour}${h0 ? ', ' : ''}${minute}`
}
// const timeInMinutes = 150; // Example: 2 hours and 30 minutes
// const { hours, minutes } = convertMinutesToHoursAndMinutes(timeInMinutes);
// console.log(`Hours: ${hours}, Minutes: ${minutes}`); // Output: Hours: 2, Minutes: 30

export const initRef = (id, db, v, pk, data={}) => {
  // const io = IO
  if (!Ref[id]) Ref[id]={}
  if (!Ref[id][db]) Ref[id][db]={}
  if (!Ref[id][db][v]) Ref[id][db][v]={}
  // if (typeof pk != 'undefined' && !Ref[id][db][v][pk]) Ref[id][db][v][pk] = data
  if (typeof pk != 'undefined') {
    if (!Ref[id][db][v][pk]) Ref[id][db][v][pk] = data
    // console.log({Row: Ref[_.ROW], id, db, v, pk, data})
    // if (isNaN(db))debugger
    return Ref[id][db][v][pk]
  }
  console.log({Ref, id, db, v, pk, data})
  return Ref[id][db][v]
}
// export const setStore = store => {
//   Ref.store = store
//   Ref.getState = store.getState
//   Ref.dispatch = store.dispatch
// }
export const MASTER = () => {
  // const store = configureStore()
  // const s = store.getState().master
  // debugger
  // const store = IO.store.getState().master
  const store = Ref.store.getState().master
  // const store = window.getState().master
if (!store) debugger
  const lang = store.lang
  const master = store.init.master?.response
  const user = store.user
  const p = store.p
  const park = store.park
  const visible = document.visibilityState === 'visible'
  return {visible, store, master, user, p, park, lang, connected: Ref.socket.connected}
}
export const promise = (callback, interval=333) => {
let count=0
  const i = setInterval(()=>{
// if (++count>30) debugger // runaway promise
if (++count>30) {debugger;callback(MASTER())} // runaway promise
    console.log({'promise': ID})
    if (callback(MASTER())) return
    console.log({'promise resolved': ID})
    clearInterval(i)
  }, interval)
}
// export const getLoginRow = (row, vendor = false) => {
export const getLoginRow = row => {
  if (row=='find') return
  const cookie = cookies()
  let vid, loginRow = row, userRow = {}
  if (Array.isArray(row)) {
    vid = row[0]
    loginRow = {
      id: row[0],
      modified: row[1],
      home: vid == _.QID ? cookie.p : row[2],
      username: row[3]
    }
    if (row.length<9) return loginRow
    userRow = {
      password: row[4],
      name: row[5],
      phone: row[6],
      email: row[7],
      city: row[8],
      state: row[9],
      country: row[10],
      taxcode: row[11],
      json: row[12],
      flag: row[13],
    }
  }
  return {...loginRow, ...userRow}
  // else {
  //   vid = row.id
  //   if (vid == _.QID) loginRow.home =  cookie.p
  // }
  // console.log({loginRow, userRow, row: {...loginRow, ...userRow}})
  // return vendor ? loginRow : {...loginRow, ...(row.length==4 ? {} : userRow)}
}
export const vendorConfig = (db, props) => {
  const { lang, p, park } = props, cookie=cookies()
  const cfgRow = getConfig(park,lang, db)
  const cfgId = cfgRow && cfgRow.id
//   const configCache = cache(`${lang}${db}${_.CONFIG}`)
// // if (db!=_.USER && (!configCache || !configCache[`0${_.PUB}`] || !configCache[`0${_.PUB}`][0])) debugger
//   if (configCache) {
//     const vCache = configCache[`0${_.PUB}`]
//     const cfgId = vCache && vCache[0]
//     const configRow = cache(`${lang}${db}${_.CONFIG}${cfgId}[]`)
//     if (configRow && !cache(`${lang}${db}${_.CONFIG}${cfgId}`)) return {} // redux is in the middle of parking
//   }
//   const parkCfg = park[_.CONFIG] && park[_.CONFIG][db] && park[_.CONFIG][db][_.DEF]
//   const parkUser = park[_.LOGIN] && park[_.LOGIN].user && park[_.LOGIN].user[_.DEF]
//   const vendorRow = parkUser && parkUser[db] || cache(`${db}`)
  const vendorRow = getRow(park, lang, 'user', 'login', db)
  if (db==_.QID && vendorRow) vendorRow.home=cookie.p
  // const cfgId = db && parkCfg && Object.keys(parkCfg)[0] || _cache && _cache[`0${_.PUB}`] && _cache[`0${_.PUB}`][0] || 0
  // const cfgRow = cfgId && parkCfg && parkCfg[cfgId] || cache(`${lang}${db}${_.CONFIG}${cfgId}`)
// if (!cfgRow) debugger
// if (!cfgId) debugger
// if (!vendorRow) debugger
  return {vendorRow, cfgId, cfgRow}
}
export const getRow = (park, lang, db, v, pk) => {
  const store = park[v]?.[db]?.default
  if (store && store[pk]) return store[pk]
  // debugger
  const key = v=='login' ? pk : `${lang}${db}${v}${pk}`
// console.log({[key]: cache(key)})
  return cache(key)
  // return v=='login' ? cache(pk) : cache(`${lang}${db}${v}${pk}`)
}
export const getConfig = (park, lang, db, v='config') => {
  const store = park?.[v]?.[db]?.default
  if (store) {
    const id = Object.keys(store)[0]
    return store[id]
  }
  const key = `${lang}${db}${v}`
  const cfg = cache(key)
  if (cfg) {
    const cfgId = cfg[`0${_.PUB}`][0]
    if (cfgId) return cache(`${key}${cfgId}`)
  }
}
export const audio = id => {
  const cookie = cookies()
  const audio = new Audio(`https://${cookie.p}.${_.DOMAIN}/usr/pub/img/${id}.mp3`)
  audio.play()
}
// export const Row = (printer, row) => {
//   let j=0
//   return Object.keys(printer[_.VIEW][_.FIELD]).reduce((fs, f, i) => {
//     if (printer[_.VIEW][_.FIELD][f]) fs[f] = row[j++]
//     return fs;
//   }, {})
// }
// export const styleChat = (text, local) => {
//   return  <div key={Date.now()} className={`${local ? _.RIGHT : _.LEFT} ${!local && _.THEME} h1`} style={{
//     margin: '5px',
//     padding: '5px',
//     // border: '1px solid #660404',
//   }}>{text}</div>
// }
// export const gId = (key, id) => `${key}${id}`
export const initialGeoCode = {
  geometry: {
    location: {
      lat: null,
      lng: null
    },
  },
  formatted_address: '',
  address_components: [],
}
////////////////////////////////////////////////
let interval = Ref.Interval
// const __interval = setInterval(()=>{
//   if (IO.Exit) clearInterval(__interval)
//   interval--
//   if (interval<0) {
//     const p = IO.store.getState().master
//     const task = IO.Task
//     task.forEach((_task, i) => {
//       const {callback, arg, delay} = _task
//       const ndelay = delay - IO.Interval
//       if (ndelay<0) {
//         IO.Task.splice(i, 1)
//         callback(...arg)
//       } else IO.Task[i].delay = ndelay
//     })
//     interval=IO.Interval
//     console.log('IO heart', {interval, p}, ...task)
//   }
// }, 1000)
////////////////////////////////////////////////
export const image = (park, user, row={}) => {
// export const image = (park, user, row={}, stage = false) => {
  const db = user.id
  // const db = stage ? -1 : user[_.ID]
  const newU = db < 0
  const shard = newU ? user.p : user.home
if (!shard) debugger
  const path = newU ? 'pub/img' : db
  const files = JSON.parse(row.medias||'[]')
  let file = 'new.jpg'
  const filePk = files.length ? files[0] : 0
  // console.log({user, db, newU, path, filePk, stage})
  if (filePk) {
    const fileRow = park.media[db].default[filePk] || cache(`${lang}${db}${_.FILE}${filePk}`)
    if (fileRow) file = `media/${fileRow.uri}.${fileRow.type}`
  }
  return {alt: user.type || 'customer', src: `https://${shard}.${_.DOMAIN}/usr/${path}/${file}`}
}
// export const isStage = id => typeof id == 'string' && id.includes(_.STAGE) && Number(id.split(_.STAGE)[1])
// export const isStage = id => typeof id == 'string' && isNaN(id)
// export const getStage = (p, uid) => {
//   const user = cookies()
//   // const login = user[_.LOGIN]
//   // const uid = Number(user[_.ID])
//   // const stage = typeof uid == 'string' && uid.includes(_.STAGE) //|| users[uid][_.STAGE]
//   const stagePk = isStage(uid)
//   // const spk = -Number(stage && uid.split('-')[1])
//   const staging = p.user[uid] && p.user[uid].staging
//   const staged = stagePk && p.user[uid].from
//   const shard = staged ? staged.p : p.user[uid] && p.user[uid][_.P]// || staged.p
//   // const npk = (stage || staging) ? (staged && staged.pk || staging || spk) : p[_.NEW_][p.master.vid][_.PURCHASE]
//   const npk = (stagePk || staging) ? (staged && staged.pk || staging || stagePk) : p[_.NEW_][p[_.P][_.VENDOR][_.ID]][_.PURCHASE]
//   // const ppk = p.master.park[_.PURCHASE][uid][_.DEF][npk]
//   const to = {[_.ID]: staged ? staged.id : uid}
//   const from = {
//     // [_.ID]: staging ? _.STAGE+staging : p.master.uid,
//     [_.ID]: staging ? _.STAGE+staging : user[_.ID],
//     [_.PK]: npk,
//   }
//   return {stagePk, staging, staged, to, from, shard}
// }
export const goOffline = (prop, tcp, tact) => {
  const lang=prop.lang, p=prop.p, park=p.park, cookie=cookies(), cid=cookie.id, vendor=p.vendor, vid=vendor.id, master=prop.init.master.response
  const customerI = master.customer.i, unknownI=master.widgetlogin.i, newI=master.new.i
  const {vendorRow, cfgId, cfgRow} = vendorConfig(vid, prop)
  const user = prop.user
  const io = {
    type: 'io',
    p: shard,
    'io': 'offline',
    data: 'offline',
    from: {
      id: cid,
      p: cookie.p,
    },
    vid,
    to: Object.keys(user).reduce((acc, id) => {
      const u = user[id]
      if (isNaN(u.id) || !u.p) return acc
      acc.push(u.id)
      return acc
    }, []),
  }
  if (io.to) tcp(io)
  // const net = Object.keys(user).reduce((acc, id) => {
  //   const u = user[id]
  //   const shard = u.p
  //   // if (isNaN(u.id) || !shard) return acc
  //   if (isNaN(u.id) || !u.p) return acc
  //   if (!acc[shard]) acc[shard] = {
  //     // debug: ID,
  //     type: 'io',
  //     p: shard,
  //     'io': 'offline',
  //     to: [u.id],
  //     data: 'offline',
  //     from: {
  //       id: cid,
  //       p: cookie.p,
  //     },
  //     vid,
  //   }
  //   if (u.stage && u.stage.pk) acc[shard].from.stage = u.stage
  //   acc[shard].to.push(id)
  //   return acc
  // }, {})
  // Object.keys(net).forEach(shard => tcp(net[shard], shard))
  tact('user')
  console.log(`go offline`, {net})
  // window.location.reload()
  const online = Ref.online
  delete(online.selected)
  // IO[_.ONLINE].toggle()
  if (online.setState) online.setState({select: 0})
}
// export const vendorConfig = (db, p) => {
//   const {lang, [_.P]: {[_.V]: park}} = p, user=cookies()
//   const configCache = cache(`${lang}${db}${_.CONFIG}`)
// // if (db!=_.USER && (!configCache || !configCache[`0${_.PUB}`] || !configCache[`0${_.PUB}`][0])) debugger
//   if (configCache) {
//     const vCache = configCache[`0${_.PUB}`]
//     const cfgId = vCache && vCache[0]
//     const configRow = cache(`${lang}${db}${_.CONFIG}${cfgId}[]`)
//     if (configRow && !cache(`${lang}${db}${_.CONFIG}${cfgId}`)) return {} // redux is in the middle of parking
//   }
//   const parkCfg = park[_.CONFIG] && park[_.CONFIG][db] && park[_.CONFIG][db][_.DEF]
//   const parkUser = park[_.LOGIN] && park[_.LOGIN].user && park[_.LOGIN].user[_.DEF]
//   const vendorRow = parkUser && parkUser[db] || cache(`${db}`)
//   if (db==_.QID && vendorRow) vendorRow.home=user[_.P]
//   const cfgId = db && parkCfg && Object.keys(parkCfg)[0] || _cache && _cache[`0${_.PUB}`] && _cache[`0${_.PUB}`][0] || 0
//   const cfgRow = cfgId && parkCfg && parkCfg[cfgId] || cache(`${lang}${db}${_.CONFIG}${cfgId}`)
// if (cfgId && !cfgRow) debugger
//   return {vendorRow, cfgId, cfgRow}
// }
// https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
export const uuid12 = () => ("10000000-1000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))
export const uuid16 = () => ("10000000-1000-4000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))
export const uuid32 = () => ("1000-100000000-8000-100000000000-4000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))
// export const uuid32 = () => ("10000000-1000-8000-100000000000-4000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))
// export const uuidv4 = () => ("10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))
export const uuidv4_ = () => ("100000000000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))
// console.log(uuidv4())
export const findVendor = p => {
if (!p)debugger
  const { verb, lang, vendor, login } = p.master
  const { db, v, park } = p
  const { pk } = p.table
  const row = park[v][db]?.default[pk]
  const vid = row && _.CART_.includes(v) ? Number(row.vendor) : vendor.id // -1 row has vid=''
  const { vendorRow, cfgId, cfgRow } = vendorConfig(vid, p)
if (cfgId && !cfgRow) return {} // redux is in the middle of parking
  const d = row ? new Date(Math.floor(row.modified*1000)) : new Date()
  // const display = cfgId && cfgId>0 ? cfgRow[_.TITLE] : (vendorRow && vendorRow!='find' ? vendorRow.username : `${d.toDateString()} ${d.toLocaleTimeString()}`)
  const display = cfgId>0 && cfgRow.title ? cfgRow.title : (vendorRow && vendorRow!='find' ? vendorRow.username : `${d.toDateString()} ${d.toLocaleTimeString()}`)
// if (!display && pk>0) debugger
if (v!='login' && !display) debugger
  return {vid, display, vendorRow, cfgId, cfgRow}
}
export const counter = ({timer=1, s=0, m=0, h=0, d=0}, callbackUpdate, callbackFinal=()=>{}) => {
  // let _s= s==0 ? 60 : s
  // let _m= s==0 ? m-1 : m
  // let _h= m==0 ? h-1 : h
  // let _d= h==0 ? h-1 : hour
  const id = setInterval(() => {
    // if (timer) s++
    // else s--
    s++
    // if (!timer && d==0 && h==0 && m==0 && s==0) {
    //   min = min==0 ? '' : `${min} min `
    //   sec = sec==0 ? '' : `${sec} sec`
    //   clearInterval(id)
    //   return finalCallback(`${min ? min + ' : ' : ''}${sec}`)
    // }
    if (s==59) {
      s=0
      m++
    }
    if (m==59) {
      m=0
      h++
    }
    if (h==23) {
      h=0
      d++
    }
    const _d = d ? `${d} day${d > 1 ? 's':''}, ` : ''
    const _h = _d || h ? `${h} : ` : ''
    const _m = _h || m ? `${m} : ` : ''
    callbackUpdate(`${_d}${_h}${_m}${s}`)
  }, 1000)
  return id
}
export const isElementVisible = el => {
  const rect = el.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    // rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  )
}
export const timer = (callback, min=0, sec=0, finalCallback=r => console.log('finishCallback', r), countDown=1) => {
  // https://dev.to/yuridevat/how-to-create-a-timer-with-react-7b9
  let s= sec==0 ? 60 : sec
  let m= sec==0 ? min-1 : min
  // let h= min==0 ? hour-1 : hour
  const id = setInterval(() => {
    s--
    if (m==0 && s==0) {
      min = min==0 ? '' : `${min} min `
      sec = sec==0 ? '' : `${sec} sec`
      clearInterval(id)
      return finalCallback(`${min ? min + ' : ' : ''}${sec}`)
    }
    if (s==0) {
      s = 60
      m--
    }
    callback(`${m ? m + ' : ' : ''}${s}`)
  }, 1000)
  return id
}
export const Test = (v, expect=false) => { // pure
  const test = v.test
  var result = true
  if (test) {
    Object.keys(test).forEach(key => {
      switch (key) {
        // case _.VERIFY:
        case 'login':
        // result = expect==test[key]
        // result = expect&&test[key]
        result = expect ? expect&&test[key] : expect==test[key]
        break
      }
    })
  }
  return result
}
// export const PKS = [_.CUSTOMER, _.VENDOR, _.EMPLOYEE, _.SHIPPER, _.FROM, _.TO, _.DRIVER]
// export const bigPks = id => PKS.reduce((acc, pk)=>{
//   if (`${_.ID}${pk}`==id) return true
//   return acc
// }, false)
export const copy = o => {
  try {
    return JSON.parse(JSON.stringify(o))
  } catch (e) {
    return e
  }
}
export const equal = (v1, v2, strict = false) => {
  if (Array.isArray(v1) && Array.isArray(v2)) {
    return JSON.stringify(v1.sort()) == JSON.stringify(v2.sort())
  }
  // console.log(v1, v2, JSON.stringify(v1), JSON.stringify(v2))
  // if (v1.pk==3)debugger
  switch(typeof v1) {
    case 'undefined': debugger
    console.log(`equal, v1=undefined, v2=`, v2)
    return equal([], Object.keys(v2 || {}))
    case 'boolean':
    case 'number':
    case 'string':
    return strict ? v1===v2 : v1==v2
    // case 'array': debugger // never happen
    case 'object':
    if (Array.isArray(v1) && Array.isArray(v2)) {
      return JSON.stringify(v1.sort()) == JSON.stringify(v2.sort())
    } else {
      console.log(`equal`, Object.keys(v1 || {}), Object.keys(v2 || {}), Object.values(v1 || {}), Object.values(v2 || {}))
      return JSON.stringify(v1 || {}) == JSON.stringify(v2 || {})
    }
  }
  debugger
}
export const cookies = key => {
  const _cookies = document.cookie.split(';').reduce((acc, curr) => {
    const [k, v] = curr.trim().split('=')
    if (k.length > 0) acc[k] = v
    return acc
  }, {})
  return key ? _cookies[key] : _cookies
}
const store = (storage, key, value) => {
  if (value) {
    storage.setItem(key, JSON.stringify(value))
    return value
  }
  value = storage.getItem(key)
  return value ? JSON.parse(value) : value
}
const _cache = (storage, key, value) => {
  const storeKeys = JSON.parse(storage.getItem('io')) || {}
  if (value) {
    storeKeys[key] = (new Date()).getTime()
    storage.setItem('io', JSON.stringify(storeKeys))
  } else if (value===null) {
    delete storeKeys[key]
    delete storeKeys[`${key}[]`]
    storage.setItem('io', JSON.stringify(storeKeys))
    storage.removeItem(key)
    storage.removeItem(`${key}[]`)
    return
  }
  return store(storage, key, value)
}
export const cache = (key, value) => _cache(localStorage, key, value)
export const session = (key, value) => _cache(sessionStorage, key, value)
// export const cacheSession = session// (key, value) => _cache(sessionStorage, key, value)
export const Route = (p=window.location.pathname) => p.split('/').reduce((acc, t, i) => {
  if (!t.length) return acc // i=0 always empty
  // if (_.LANG_.includes(t)) return acc
  switch(i) {
    case 4:
    case 5:
    case 6: debugger
    case 1: break // always master or vendorname
    case 2: if (_.PART_.includes(t) || t=='otp') break
    case 3: if (Number.isInteger(Number(t))) acc.push(Number(t)) // no break
    default: return acc
  }
  acc.push(t)
  return acc
}, [])
// export const session = (key, value) => store(sessionStorage, key, value)
export const Param = (param=window.location.search) => param.split('?').reduce((accToken, token) => {
  if (token) {
    token.split('&').forEach(keyValue => {
      if (keyValue) {
        const pair = keyValue.split('=')
        switch (pair[0]) {
          case 'lang':
          // case 'first':
          accToken[pair[0]] = pair.length > 1 ? pair[1] : ''
          // break
        }
        // if (pair.length==2) accToken[pair[0]] = pair[1]
      }
    })
  }
  return accToken
}, {'lang': _.EN})
export const INDEX = (reset=false) => {
  const _index = cache('index') || 0
  const index = reset ? 1 : _index + 1
  cache('index', index)
  return index
}
export const STAGE = cache('stage') || {}
export const stage = (id, user) => {
  if (user) {
    const u = copy(user)
    delete(u.p)
    u.time = Date.now()
    STAGE[id] = u
  } else delete(STAGE[id])
  cache('stage', STAGE)
}

export var Blank = {}
export const setBlank = blank => Blank = blank
export const getBlank = () => Blank
// var __PK__ = 0
// const Pk = () => --__PK__
// export const newRow = (prop, db, v) => {
//   const {verb, uid, lang, vid, vendor, route, u, views, login, park, cookie, owner} = prop.master
//   const printer = park[v][verb]
// if (!printer)debugger
//   // const pk = Pk()
//   const pk = v=='login' ? uid : Pk()
//   // console.log(Object.keys(printer[_.VIEW][_.FIELD]).map(f=>printer[_.VIEW][_.FIELD][f]))
//   // console.log(Object.keys(printer[_.VIEW][_.FIELD]))
//   const modified = Math.floor(Date.now()/1000)
//   const row = Object.keys(printer.view.field).reduce((fs, f, i) => {
//     // if (f==JSONDELIVER)debugger
//    if (f==v || !printer.view.field[f]) return fs
//     switch (f) {
//       // case v: return fs
//       // case JSONDELIVER:// JSON.stringify(fs.push(..._.JSONDELIVER_)); break
//       // debugger
//       case 'map': fs.push(JSON.stringify(initialGeoCode)); break
//       // fs.push(printer[_.PART][f]['v']['input']['value'])
//       // break
//       case 'jsondeliver':// JSON.stringify(fs.push(..._.JSONDELIVER_)); break
//       case 'selectmedia':
//       case 'items':
//       case 'medias':
//       case 'reviews':
//       case 'json': //case `${_.JSON}${_.CART}`: case `${_.JSON}${_.DELIVER}`:
// //      debugger
//       fs.push('[]')
//       break
//       case 'from':
//       case 'customer':
//       fs.push(uid)
//       break
//       // case _.TO:
//       case 'vendor':   fs.push(vid || ''); break
//       case 'id':       fs.push(pk); break
//       case 'rate':     fs.push(_.RATE_M); break
//       case 'expire':   fs.push(0); break
//       case 'modified': fs.push(modified); break
//       case 'lang':     fs.push(lang); break
//       case 'print':   fs.push(1); break
//       case 'ref':      fs.push(uuidv4()); break
//       // case _.TYPE:     fs.push(1); break
//       default:         fs.push('')
//     }
//     // console.log({f, i})
//     return fs
//   }, [])
//   if (row.length==0) row.push(pk)
//   if (![db]) Blank[db] = {}
//   Blank[db][v]=pk
//   let _row = row
//   // if (v=='login') _row = [pk, modified, '', '', '', '', '', '', '', '', '', '', '[]', '']
//   if (v=='login') _row = [pk, modified, '', '', '', '', '', '']
//   // if (v=='login') _row = [pk, modified, '', '']
//   setTimeout(() => {
//     if (v=='purchase' && STAGE[vid]) {
//       // _row = STAGE[vid].purchase
//       _row = Object.keys(STAGE).reduce((acc, id) => {
//         if (STAGE[id].id==vid) return STAGE[id].purchase
//         return acc
//       }, row)
//   }
//     // if (v==_.PURCHASE) {
//     //   const sess = session(v) || {}
//     //   // if (sess[vid] && sess[vid].now > Date.now()) {
//     //   if (sess[vid]) {
//     //     sess[vid].row[_.ID] = pk
//     //     _row = sess[vid].row
//     //   }
//     // }
//     dispatch({verb, buffer: {[cookie.p]: {[v]: {[db]: {default: {[pk]: _row}}}}}})
//     prop.action.new(copy(Blank))
//     // if (v==_.PURCHASE) {
//     //   const cartCount = copy(prop.master.cartCount)
//     //   cartCount[db] = ''
//     //   prop.setMaster({cartCount})
//     // }
//     console.log({[ID]: 'New', db, v, pk, _row, Blank})
//     // debugger
//   }, 1)
//   return pk
// }
// if (!IO.table) IO.table = {setBlank, getBlank, newRow}
// IO[_.TABLE].setBlank = setBlank
// IO[_.TABLE].getBlank = getBlank
// IO[_.TABLE].newRow = newRow
